// Session SC2A: the one shared debounce for typeahead pickers. Returns `value` once it has stopped changing for `ms`.
import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, ms = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
